import DataGrid, { Column } from 'devextreme-react/data-grid';
import { bllSharedCellStyling } from '../../common/constants/tables/cells/styles/bllSharedCellStyling';
import { BorrowerLendingLimitTableType } from '../../common/constants/tables/BorrowerLendingLimitTableType';
import { currencyCellItemRender } from '../../common/constants/tables/cells/renders/currencyCellItemRender';
import { countCellRender } from '../../common/constants/tables/cells/renders/countCellRender';
import {
    SummaryItemStyleMode,
    summaryItemTypeCellRender,
} from '../../common/constants/tables/cells/renders/summaryItemCellRender';
import { CoreColumns } from '../../common/constants/tables/columns/CoreColumns';
import { CoreRows } from '../../common/constants/tables/rows/CoreRows';
import { ILoanHistorySummaryTableRow } from '../../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { ICoreTableRow } from '../../common/constants/tables/interfaces/ICoreTableRow';

interface CoreTableProps {
    coreData: ICoreTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const CoreTable: React.FC<CoreTableProps> = ({ onLoanSummaryClick, coreData }) => {
    const rowSpecificCellStyling = (e) => {
        switch (e.row?.data?.summaryItemType) {
            case CoreRows.SubTotal:
                e.cellElement.style.borderTop = '2px solid gray';
                break;
            default:
                break;
        }
    };

    const prepareCells = (e) => {
        //Run shared styling
        bllSharedCellStyling(e);

        //Run row specific styling
        rowSpecificCellStyling(e);
    };

    const showEyeForCore = (e) =>
        [
            CoreRows.Construction,
            CoreRows.FixFlip,
            CoreRows.Land,
            CoreRows.SubTotal,
            CoreRows.ExcessBridge,
            CoreRows.Core,
        ].includes(e.data.summaryItemType);

    const getSummaryItemTypeStyleMode = (rowType: CoreRows) =>
        rowType === CoreRows.ExcessBridge ? SummaryItemStyleMode.Italic : SummaryItemStyleMode.Bold;

    return (
        <>
            <DataGrid
                dataSource={coreData}
                keyExpr='summaryItemType'
                showBorders={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No Core Information Available'
                onCellPrepared={(e) => {
                    prepareCells(e);
                }}
                style={{ padding: '10px' }}
            >
                <Column
                    dataField={CoreColumns.SummaryItemType}
                    caption=''
                    alignment='left'
                    width={160}
                    cellRender={(e) =>
                        summaryItemTypeCellRender(
                            e,
                            BorrowerLendingLimitTableType.Core,
                            CoreColumns.SummaryItemType,
                            getSummaryItemTypeStyleMode(e.data.summaryItemType)
                        )
                    }
                />

                <Column
                    dataField={CoreColumns.OutstandingAmount}
                    caption='Outstanding'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Core)}
                />
                <Column
                    dataField={CoreColumns.OutstandingNumber}
                    caption=''
                    width={70}
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.outstandingLoans),
                            showEyeForCore
                        )
                    }
                />
                <Column
                    dataField={CoreColumns.BfiRepaysAmount}
                    caption='BFI Repays'
                    width={120}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Core)}
                />
                <Column
                    dataField={CoreColumns.BfiRepaysNumber}
                    caption=''
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.bfiRepaysLoans),
                            showEyeForCore
                        )
                    }
                />
                <Column
                    dataField={CoreColumns.ExternalNumber}
                    caption='External'
                    alignment={'right'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.externalLoans),
                            showEyeForCore
                        )
                    }
                />
            </DataGrid>
        </>
    );
};
